import { useEffect, useRef, useState } from 'react';
import useSessionManager from './useSessionManager';

export default () => {
  const sessionManager = useSessionManager();
  const sessionManagerRef = useRef(sessionManager);
  const [isAuthenticated, setIsAuthenticated] = useState(sessionManager?.isAuthenticated ?? false);
  const [isAuthorizing, setIsAuthorizing] = useState(sessionManager?.isAuthorizing ?? false);

  useEffect(() => {
    sessionManagerRef.current = sessionManager;
  });

  useEffect(() => {
    const { current: currentSessionManager } = sessionManagerRef;

    const handleIsAuthenticated = ({
      isAuthenticated: authenticated,
      isAuthorizing: authorizing,
    }) => {
      setIsAuthenticated(authenticated);
      setIsAuthorizing(authorizing);
    };

    if (currentSessionManager) {
      currentSessionManager.registerAuthenticationHandler(handleIsAuthenticated);
    }

    return () => {
      if (currentSessionManager) {
        currentSessionManager.unregisterAuthenticationHandler(handleIsAuthenticated);
      }
    };
  }, []);

  return [isAuthenticated, isAuthorizing];
};
